import { NavLink } from 'react-router';

import { useAgencyConfiguration } from '@/app/shell/agencyConfiguration';

export function WhiteLabelLogo() {
  const agencyConfiguration = useAgencyConfiguration();

  const appName = agencyConfiguration.agencyPortalConfiguration.showAppNameInNavigation
    ? agencyConfiguration.agencyPortalConfiguration.appName
    : null;
  const logoSrc = `${agencyConfiguration.agencyPortalConfiguration.logoFolderPath}/logo.svg`;

  const baseCssClass =
    'd-flex gap-2 align-items-center me-3 text-white text-decoration-none small fw-bold';

  return (
    <NavLink
      to="/incident-list"
      end
      className={({ isActive }) => (isActive ? `${baseCssClass} active` : baseCssClass)}
    >
      <img src={logoSrc} alt="Logo" className="logo" style={{ height: '40px' }} />

      {appName}
    </NavLink>
  );
}
